// Plain-language messages for Firebase Auth errors. Players must never see raw
// Firebase text such as "Firebase: Error (auth/invalid-credential)."

const MESSAGES = {
  // Firebase deliberately returns invalid-credential for both a wrong password
  // and an unknown email, so we can't (and shouldn't) say which it was.
  'auth/invalid-credential': "That email and password don't match. Check them and try again, or reset your password.",
  'auth/invalid-login-credentials': "That email and password don't match. Check them and try again, or reset your password.",
  'auth/wrong-password': "That email and password don't match. Check them and try again, or reset your password.",
  'auth/user-not-found': "That email and password don't match. Check them and try again, or reset your password.",
  'auth/invalid-email': "That email doesn't look right. Check it and try again.",
  'auth/missing-email': 'Enter your email address.',
  'auth/missing-password': 'Enter your password.',
  'auth/too-many-requests': 'Too many tries. Wait a few minutes and try again, or reset your password.',
  'auth/network-request-failed': "We couldn't reach the server. Check your connection and try again.",
  'auth/user-disabled': 'This account has been switched off. Email us if you think that is a mistake.',
  'auth/email-already-in-use': "There's already an account with this email. Sign in instead.",
  'auth/credential-already-in-use': 'This account is already linked to another NameIt! account.',
  'auth/account-exists-with-different-credential': 'This email already has an account that signs in a different way. Use that method instead.',
  'auth/weak-password': 'Use a password with at least 6 characters.',
  'auth/requires-recent-login': 'For your security, sign in again and then retry.',
  'auth/popup-closed-by-user': 'Sign-in was cancelled.',
  'auth/cancelled-popup-request': 'Sign-in was interrupted. Please try again.',
  'auth/popup-blocked': 'Your browser blocked the sign-in popup. Allow popups for this site and try again.',
  'auth/expired-action-code': 'This link has expired. Ask for a new one.',
  'auth/invalid-action-code': 'This link is no longer valid. Ask for a new one.',
};

/**
 * A message safe to show players for any auth error. `fallback` phrases the
 * unknown-error case for the action at hand (default "Something went wrong").
 */
export function authErrorMessage(error, fallback = 'Something went wrong') {
  const code = error?.code;
  if (code && MESSAGES[code]) return MESSAGES[code];
  return `${fallback}. Please try again.`;
}
